import React, { useState, useEffect, Fragment } from "react";
import { Layout, Grid, Button, message } from "antd";
import { CopyrightCircleOutlined } from "@ant-design/icons";
import "./FullLayout.less";
import Sidebar from "./Sidebar";
import Navbar from "./Navbar";
import Axios from "axios";
import { url } from "../config/global";

const { Header, Footer, Sider, Content } = Layout;
const { useBreakpoint } = Grid;

function FullLayout(props) {
  const [collapsed, setCollapsed] = useState(false);
  const [hidesidebar, setSidebar] = useState(false);
  const screens = useBreakpoint();

  const handleCollapsed = () => {
    setCollapsed(!collapsed);
    setSidebar(!hidesidebar);
  };

  useEffect(() => {
    if (sessionStorage.getItem("username") == "dashboard-incoming") {
      setSidebar(true);
    }
    const width = window.innerWidth;
    // show collapsed sidebar (icon bar) by default on small screens so header aligns
    width <= 500 && setCollapsed(true);
  }, []);

  const refresh = () => {
    const path = props.history.location.pathname;
    window.location = path;
  };

  const handleLogout = () => {
    console.log("terclick");
    let fd = new FormData();
    fd.set("id_user", sessionStorage.getItem("id_user"));
    Axios.post(`${url}/logout`, fd, {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${sessionStorage.getItem("token")}`,
      },
    })
      .then((res) => {
        console.log("Logout");
        sessionStorage.removeItem("token");
        sessionStorage.removeItem("id_user");
        sessionStorage.removeItem("parent_item");
        sessionStorage.removeItem("shift_code");
        sessionStorage.removeItem("dn_no");
      })
      .catch((err) => {
        if (err.response) {
          message.error(err.response.data.message);
        }
      });
    return props.history.push("/login");
  };

  // Calculate margin left based on sidebar state
  const getContentStyle = () => {
    if (hidesidebar) return { marginLeft: 0 };
    if (screens.xs) {
      // on mobile, when collapsed show small sidebar (80), else full sidebar (256)
      return collapsed ? { marginLeft: 80 } : { marginLeft: 256 };
    }
    return collapsed ? { marginLeft: 80 } : { marginLeft: 256 };
  };

  return (
    <Layout style={{ minHeight: "100vh" }}>
      {!hidesidebar && (
        <Sider
          breakpoint="lg"
          onBreakpoint={(broken) => {
            setCollapsed(broken);
          }}
          className={`sidebar ${
            screens.xs
              ? collapsed
                ? "sidebar-collapsed"
                : "sidebar-uncollapsed"
              : collapsed
              ? "sidebar-collapsed"
              : "sidebar-uncollapsed"
          }`}
          trigger={null}
          collapsed={collapsed}
          style={{
            overflow: "auto",
            height: "100vh",
            position: "fixed",
            left: 0,
            top: 0,
            bottom: 0,
          }}
        >
          <Sidebar {...props} collapsed={collapsed} />
        </Sider>
      )}

      <Layout style={getContentStyle()}>
        {sessionStorage.getItem("username") != "dashboard-incoming" && (
          <Header
            className="header"
            style={{
              width: hidesidebar
                ? "100%"
                : screens.xs
                ? collapsed
                  ? "calc(100% - 80px)"
                  : "calc(100% - 256px)"
                : collapsed
                ? "calc(100% - 80px)"
                : "calc(100% - 256px)",
            }}
          >
            <Navbar
              {...props}
              refresh={refresh}
              collapsed={collapsed}
              screens={screens}
              onToggleCollapsed={handleCollapsed}
            />
          </Header>
        )}

        <Content
          style={{
            marginTop: hidesidebar ? 64 : 0,
            minHeight: "calc(100vh - 64px)",
          }}
        >
          <Fragment>{props.children}</Fragment>
        </Content>

        {/* <Footer>
          <CopyrightCircleOutlined /> 2024 Sankei Dharma Indonesia 
          {sessionStorage.getItem("username") == 'dashboard-incoming' && (
            <Button type="link" onClick={() => handleLogout()}>Logout</Button>
          )}
        </Footer> */}
      </Layout>
    </Layout>
  );
}

export default FullLayout;
